import { useState } from 'react';
import PartnerInquiryModal from './PartnerInquiryModal';

export default function Contact() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [showSuccessBanner, setShowSuccessBanner] = useState(false);

  const handleSuccess = () => {
    setShowSuccessBanner(true);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <>
      {showSuccessBanner && (
        <div className="fixed top-0 left-0 right-0 z-[60] bg-gradient-to-r from-green-600 to-green-700 text-white py-3 px-3 shadow-2xl animate-slide-down">
          <div className="max-w-4xl mx-auto">
            <div className="flex items-start gap-3">
              <div className="w-8 h-8 flex items-center justify-center bg-white/20 rounded-full flex-shrink-0">
                <i className="ri-check-line text-xl"></i>
              </div>
              <div className="flex-1 min-w-0 pr-2">
                <h3 className="text-base font-bold mb-1">Thanks for getting in touch!</h3>
                <p className="text-sm text-white/95 leading-relaxed">
                  We're excited to connect and see how we can work together. We've received your message and will follow up with you shortly. Feel free to call us directly at <a href="tel:+14132227701" className="font-semibold underline hover:text-yellow-300 transition-colors cursor-pointer whitespace-nowrap">(413) 222-7701</a>.
                </p>
                <p className="text-xs text-white/80 mt-2">
                  — Chris Leary, Founder and Tour Director, Bucket List Golf
                </p>
              </div>
              <button
                onClick={() => setShowSuccessBanner(false)}
                className="text-white hover:text-white/80 transition-colors cursor-pointer flex-shrink-0 w-8 h-8 flex items-center justify-center -mr-1"
                aria-label="Close banner"
              >
                <i className="ri-close-line text-2xl"></i>
              </button>
            </div>
          </div>
        </div>
      )}

      <section id="contact" className="py-12 sm:py-16 lg:py-24 bg-gray-50">
        <div className="max-w-4xl mx-auto px-4 sm:px-6">
          <div className="text-center mb-8 sm:mb-10 lg:mb-12">
            <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 mb-4 sm:mb-6 px-2">
              Think our brands might align?
            </h2>
            <div className="w-16 sm:w-20 h-1 bg-green-700 mx-auto rounded-full mb-6 sm:mb-8"></div>
            <p className="text-base sm:text-lg md:text-xl text-gray-700 px-2">
              Let's start a conversation about how you can be part of the journey.
            </p>
          </div>

          <div className="bg-white rounded-2xl shadow-xl p-6 sm:p-8 md:p-10 lg:p-12">
            <div className="space-y-5 sm:space-y-6">
              <div className="flex items-start gap-3 sm:gap-4">
                <div className="w-10 h-10 sm:w-12 sm:h-12 flex items-center justify-center bg-green-100 rounded-full flex-shrink-0">
                  <i className="ri-mail-line text-xl sm:text-2xl text-green-700"></i>
                </div>
                <div>
                  <div className="text-xs sm:text-sm font-semibold text-gray-500 uppercase tracking-wide mb-1">
                    Email
                  </div>
                  <a
                    href="mailto:Info@BucketListGolf.org"
                    className="text-base sm:text-lg md:text-xl font-semibold text-green-700 hover:text-green-800 transition-colors cursor-pointer break-all"
                  >
                    Info@BucketListGolf.org
                  </a>
                </div>
              </div>

              <div className="flex items-start gap-3 sm:gap-4">
                <div className="w-10 h-10 sm:w-12 sm:h-12 flex items-center justify-center bg-green-100 rounded-full flex-shrink-0">
                  <i className="ri-phone-line text-xl sm:text-2xl text-green-700"></i>
                </div>
                <div>
                  <div className="text-xs sm:text-sm font-semibold text-gray-500 uppercase tracking-wide mb-1">
                    Phone
                  </div>
                  <a
                    href="tel:+14132227701"
                    className="text-base sm:text-lg md:text-xl font-semibold text-green-700 hover:text-green-800 transition-colors cursor-pointer"
                  >
                    (413) 222-7701
                  </a>
                </div>
              </div>

              <div className="flex items-start gap-3 sm:gap-4">
                <div className="w-10 h-10 sm:w-12 sm:h-12 flex items-center justify-center bg-green-100 rounded-full flex-shrink-0">
                  <i className="ri-user-line text-xl sm:text-2xl text-green-700"></i>
                </div>
                <div>
                  <div className="text-xs sm:text-sm font-semibold text-gray-500 uppercase tracking-wide mb-1">
                    Contact Person
                  </div>
                  <div className="text-base sm:text-lg md:text-xl font-semibold text-gray-900">
                    Chris Leary
                  </div>
                  <div className="text-sm sm:text-base text-gray-600 mt-1">
                    Founder and Tour Director
                    <br />
                    Bucket List Golf
                  </div>
                </div>
              </div>
            </div>

            <div className="mt-8 sm:mt-10 pt-6 sm:pt-8 border-t border-gray-200 text-center">
              <button
                onClick={() => setIsModalOpen(true)}
                className="bg-gradient-to-r from-yellow-400 to-yellow-500 hover:from-yellow-500 hover:to-yellow-600 text-gray-900 font-bold py-3 sm:py-4 px-6 sm:px-8 rounded-full transition-all duration-300 hover:scale-105 hover:shadow-xl hover:shadow-yellow-500/50 whitespace-nowrap cursor-pointer text-sm sm:text-base"
              >
                Get In Touch
              </button>
            </div>
          </div>
        </div>
      </section>

      <footer className="bg-black text-white py-16 sm:py-20 border-t border-yellow-400/20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-8">
            <div className="sm:col-span-2 md:col-span-2">
              <img
                alt="Bucket List Golf"
                className="h-12 w-auto mb-6"
                src="https://static.readdy.ai/image/57c982531ce74d8992a8785896e0bafd/3583e5e2b78d0b331199ba2568c9c533.png"
              />
              <p className="text-white/60 mb-8 max-w-md text-base sm:text-lg leading-relaxed">
                Exclusive access to America's most coveted golf courses through curated tournaments and events.
              </p>
              <div className="flex space-x-4">
                <a
                  href="https://facebook.com/bucketlistgolfseries"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-12 h-12 bg-yellow-400 rounded-full flex items-center justify-center hover:bg-yellow-300 transition-colors cursor-pointer"
                >
                  <i className="ri-facebook-fill text-black text-lg"></i>
                </a>
                <a
                  href="https://instagram.com/bucketlistgolfseries"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-12 h-12 bg-yellow-400 rounded-full flex items-center justify-center hover:bg-yellow-300 transition-colors cursor-pointer"
                >
                  <i className="ri-instagram-line text-black text-lg"></i>
                </a>
              </div>
            </div>

            <div>
              <h4 className="text-lg sm:text-xl font-bold mb-6 text-yellow-400">Quick Links</h4>
              <ul className="space-y-3">
                <li>
                  <a
                    href="https://bucketlistgolf.org/events"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-white/60 hover:text-white transition-colors cursor-pointer text-base sm:text-lg"
                  >
                    Upcoming Events
                  </a>
                </li>
                <li>
                  <a
                    href="https://bucketlistgolf.org/bulletin"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-white/60 hover:text-white transition-colors cursor-pointer text-base sm:text-lg"
                  >
                    Bucket List Bulletin
                  </a>
                </li>
                <li>
                  <a
                    href="https://bucketlistgolf.org/membership#bucket-list-society-signup"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-white/60 hover:text-white transition-colors cursor-pointer text-base sm:text-lg"
                  >
                    Membership
                  </a>
                </li>
                <li>
                  <a
                    href="https://bucketlistgolf.org/about"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-white/60 hover:text-white transition-colors cursor-pointer text-base sm:text-lg"
                  >
                    About Us
                  </a>
                </li>
                <li>
                  <button
                    onClick={() => setIsModalOpen(true)}
                    className="text-white/60 hover:text-white transition-colors cursor-pointer text-base sm:text-lg text-left"
                  >
                    Contact
                  </button>
                </li>
              </ul>
            </div>

            <div>
              <h4 className="text-lg sm:text-xl font-bold mb-6 text-yellow-400">Contact Info</h4>
              <ul className="space-y-3 text-white/60">
                <li className="flex items-center text-base sm:text-lg">
                  <i className="ri-phone-line mr-3 text-yellow-400"></i>
                  +1 (413) 222-7701
                </li>
                <li className="flex items-center text-base sm:text-lg">
                  <i className="ri-mail-line mr-3 text-yellow-400"></i>
                  Info@BucketListGolf.org
                </li>
              </ul>
            </div>
          </div>

          <div className="border-t border-white/10 mt-12 sm:mt-16 pt-6 sm:pt-8 flex flex-col sm:flex-row justify-between items-center text-white/40 text-sm sm:text-base">
            <p>© 2026 Bucket List Golf, LLC. All rights reserved.</p>
          </div>
        </div>
      </footer>

      <PartnerInquiryModal 
        isOpen={isModalOpen} 
        onClose={() => setIsModalOpen(false)}
        onSuccess={handleSuccess}
      />
    </>
  );
}
